import Vue from 'vue';
import Image from './Image.vue';
import SvgIcon from '../../common/Icon.vue';
Vue.component('svg-icon', SvgIcon);
export default (props) => {
  /**
   * props中的字段
   * url
   * originUrl 老数据中存在originUrl字段
   * description
   * attachmentId
   * filename
   * heigth
   * width
   * thumbnailUrl
   * env
   * enableJsbridge
   */
  const Constructor = Vue.extend(Image);
  const {
    originUrl = '',
    url = '',
    thumbnailUrl = '',
    description = '',
    filename = '',
    attachmentId = '',
    width = 0,
    height = 0,
    unwell = 0,
    lockUnwell = 0
  } = props;
  console.log(props, 'props')
  const component = new Constructor({
    propsData: { ...props },
    data: {
      attachmentId,
      url: url || originUrl,
      thumbnailUrl: thumbnailUrl || url || originUrl,
      description,
      filename,
      width,
      height,
      unwell,
      lockUnwell
    }
  });
  return { component };
};
